import React from "react";

/**
 * Phase 7 — DTC code chip + severity pill.
 *
 * Severity → background classes (Tailwind), explicit RGB on the chip so the
 * Playwright spec can computed-style assert against the palette without
 * caring about ResolvedColor differences.
 */
const PALETTE = {
    info:     { bg: "#0ea5e9", fg: "#ffffff" },   // sky-500
    low:      { bg: "#10b981", fg: "#ffffff" },   // emerald-500
    medium:   { bg: "#f59e0b", fg: "#1f2937" },   // amber-500
    high:     { bg: "#f43f5e", fg: "#ffffff" },   // rose-500
    critical: { bg: "#dc2626", fg: "#ffffff" },   // cherry-red-600
    unknown:  { bg: "#6b7280", fg: "#ffffff" },   // slate-500
};

export function severityPalette(severity) {
    return PALETTE[severity] || PALETTE.unknown;
}

export function DtcCodeChip({ code, severity = "unknown", description = "", className = "", "data-testid": testId }) {
    const p = severityPalette(severity);
    return (
        <span
            data-testid={testId || `dtc-chip-${code}`}
            title={description || code}
            className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-mono font-semibold tracking-wide ${className}`}
            style={{ backgroundColor: p.bg, color: p.fg }}
        >
            <span data-testid="dtc-chip-code">{code}</span>
            <span
                data-testid="dtc-chip-severity"
                className="opacity-80 text-[10px] uppercase font-sans tracking-widest"
            >
                {severity}
            </span>
        </span>
    );
}
